(function() {
    "use strict";

    angular.module("laekkerAI.tablet").component("goodsReceiving", {
        templateUrl: "/components/goods-receiving/goods-receiving.html",
        controller: "GoodsReceivingController",
        bindings: {}
    });
})();
